import ClientFilter from './ClientFilter';
import { ClientDataForm } from '../../../../app/models/Client';
import { SocietyClientFilters } from '../../../../app/models/SocietyClient';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ActiveControl from '../../../../components/ActiveControl';
import { CarrierDataForm } from '../../../../app/models/Carrier';
import ClientSwitchChange from '../ClientSwitchChange';

interface Props {
    clients: ClientDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: SocietyClientFilters;
    setFilter: (filter: SocietyClientFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const ClientDataTable = ({
    clients,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'RUT Sociedad',
            selector: (row: any) => row.society?.rut || '',
            sortable: true,
            sortField: 'society__rut',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="">{row.society?.rut ?? '-'}</span>
            )
        },
        {
            name: 'Razón Social Sociedad',
            selector: (row: any) => row.society?.business_name || '',
            sortable: true,
            sortField: 'society__business_name',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="" title={row.society?.business_name}>{row.society?.business_name ?? '-'}</span>
            )
        },
        {
            name: 'RUT Cliente',
            selector: (row: any) => row.rut,
            sortable: true,
            sortField: 'rut',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="">{row.rut}</span>
            )
        },
        {
            name: 'Razón Social Cliente',
            selector: (row: any) => row.business_name,
            sortable: true,
            sortField: 'business_name',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="" title={row.business_name}>{row.business_name}</span>
            )
        },
        {
            name: 'Dirección Cliente',
            selector: (row: any) => row.address,
            sortable: true,
            sortField: 'address',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="">{row.address}</span>
            )
        },
        {
            name: 'País Cliente',
            selector: (row: any) => row.country,
            sortable: true,
            sortField: 'country',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <span className="">{row.country}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: ClientDataForm, index: any, column: any) => (
                <ClientSwitchChange
                    checkValue={row.is_active ?? true}
                    societyClientId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: ClientDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <ClientFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={clients}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default ClientDataTable;
